// extracted by mini-css-extract-plugin
export default {"container":"BasicLayout_container__kHjYU","content":"BasicLayout_content__1ONZ-"};